import React, { useEffect } from 'react';
import { Typography } from '@mui/material';
import InputFluidRequirementIcon from '../../assets/icons/inputFluidRequirementIcon.svg';
import { BoxStyled, TypographyStyledHeader } from '../patientInformation/style';
import { ArcContainer } from '../../shared/components/arcContainer';
import { TabPanel } from '../../shared/components/tabPanel';
import { TypographyH4Bold } from '../estimatingRequirements/paedFluid/style';
import { BottleView } from './bottleView';
import { MlView } from './mLView';
import { useAppSelector } from '../../store/hooks';
import { metaDataSelector } from '../../store/globalSelectors';
import { useDispatch } from 'react-redux';
import {
  setCompareData,
  setCompareP1VolumeOffset,
  setCompareP2VolumeOffset
} from '../../store/slices/metaDataSlice';
import { NavigationButtons } from '../../shared/components/navigationButtons';

const InputScreen = () => {
  const dispatch = useDispatch();
  const { compare } = useAppSelector(metaDataSelector);
  const {
    selectedProducts,
    bottleInputP1,
    bottleInputP2,
    volumeInputP1,
    volumeInputP2
  } = compare;

  // useEffect(() => {

  // }, []);

  useEffect(() => {
    // Calculate p1VolumeCalculationOffset
    if (volumeInputP1) {
      dispatch(setCompareP1VolumeOffset(volumeInputP1));
    } else if (bottleInputP1) {
      const perBottleVol = selectedProducts[0].volumeOffset;
      const totalVol = bottleInputP1 * perBottleVol;
      dispatch(setCompareP1VolumeOffset(totalVol));
    }
  }, [volumeInputP1, bottleInputP1, selectedProducts]);

  useEffect(() => {
    // Calculate p2VolumeCalculationOffset
    if (volumeInputP2) {
      dispatch(setCompareP2VolumeOffset(volumeInputP2));
    } else if (bottleInputP2) {
      const perBottleVol = selectedProducts[1].volumeOffset;
      const totalVol = bottleInputP2 * perBottleVol;
      dispatch(setCompareP2VolumeOffset(totalVol));
    }
  }, [volumeInputP2, bottleInputP2, selectedProducts]);
  return (
    <>
      <BoxStyled>
        <TypographyStyledHeader>{`PRODUCTS`}</TypographyStyledHeader>

        <ArcContainer icon={InputFluidRequirementIcon} customizedHeight="auto">
          <TypographyH4Bold sx={{ textAlign: 'center' }} className="pt-16">
            {selectedProducts.length > 0 ? selectedProducts[0].name : ''}
            <Typography sx={{ fontFamily: 'CalibriItalic', fontSize: '1rem' }}>
              {selectedProducts.length > 0
                ? `${selectedProducts[0].category} - ${selectedProducts[0].volume}`
                : ''}
            </Typography>
          </TypographyH4Bold>

          <TabPanel
            tabs={[
              selectedProducts.length > 0 && selectedProducts[0].typeofcategory,
              'mL'
            ]}
            panelData={[
              <BottleView
                setBottleInput={(val) => {
                  dispatch(
                    setCompareData({
                      ...compare,
                      bottleInputP1: val
                    })
                  );
                }}
                key={0}
                value={bottleInputP1}
                typeofcategory={
                  selectedProducts.length > 0
                    ? selectedProducts[0].typeofcategory
                    : 'Bottle'
                }
              />,
              <MlView
                setMlInput={(val) => {
                  dispatch(
                    setCompareData({
                      ...compare,
                      volumeInputP1: val
                    })
                  );
                }}
                key={1}
                value={volumeInputP1}
              />
            ]}
          />
        </ArcContainer>

        <ArcContainer icon={InputFluidRequirementIcon} customizedHeight="auto">
          <TypographyH4Bold sx={{ textAlign: 'center' }} className="pt-16">
            {selectedProducts.length > 1 ? selectedProducts[1].name : ''}
            <Typography sx={{ fontFamily: 'CalibriItalic', fontSize: '1rem' }}>
              {selectedProducts.length > 1
                ? `${selectedProducts[1].category} - ${selectedProducts[1].volume}`
                : ''}
            </Typography>
          </TypographyH4Bold>

          <TabPanel
            tabs={[
              selectedProducts.length > 1 && selectedProducts[1].typeofcategory,
              'mL'
            ]}
            panelData={[
              <BottleView
                setBottleInput={(val) => {
                  dispatch(
                    setCompareData({
                      ...compare,
                      bottleInputP2: val
                    })
                  );
                }}
                key={0}
                value={bottleInputP2}
                typeofcategory={
                  selectedProducts.length > 1
                    ? selectedProducts[1].typeofcategory
                    : 'Bottle'
                }
              />,
              <MlView
                setMlInput={(val) => {
                  dispatch(
                    setCompareData({
                      ...compare,
                      volumeInputP2: val
                    })
                  );
                }}
                key={1}
                value={volumeInputP2}
              />
            ]}
          />
        </ArcContainer>
        <NavigationButtons
          nextDisabled={
            !(
              bottleInputP1 !== volumeInputP1 && bottleInputP2 !== volumeInputP2
            )
          }
          nextRoute={'/compare/table'}
          nextVisible={true}
        />
      </BoxStyled>
    </>
  );
};

export { InputScreen };
